import { PUSH } from 'layers/navigation/store/types'
import {
  TABLE_URL_PARAMS,
  TIER2_GRADE_BAND_KEYS,
} from 'store/reportsManager/constants'
import { LESSON_COMPLETION_PATH } from './constants'

export const createSeeLessonCompletionHandler = navigationEvent => {
  return (siteId, gradeBand = TIER2_GRADE_BAND_KEYS.K_2) => {
    // Construct path with grade band
    // If siteId is provided, include it as a query param
    // If not provided, page will default to first site in activeAdminK8Sites
    let path = `${LESSON_COMPLETION_PATH}${gradeBand}`
    if (siteId) {
      path += `?${TABLE_URL_PARAMS.SITE_ID}=${siteId}`
    }
    navigationEvent(path, PUSH)
  }
}
